import styled, { css } from "styled-components";

export const FormWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;

    @media only screen and (max-width: 600px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
`;

export const FiltersWrapper = styled.div`
    grid-column: span 2 / span 2;
    display: flex;
    flex-direction: column;
    gap: 5px;

    @media only screen and (max-width: 600px) {
        grid-column: span 1 / span 1;
    }
`;

export const Form = styled.form`
    grid-column: span 2 / span 2;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;

    @media only screen and (max-width: 600px) {
        grid-column: span 1 / span 1;
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
`;

export const TabsWrapper = styled.div`
     grid-column: span 2 / span 2;

     @media only screen and (max-width: 600px) {
        grid-column: span 1 / span 1;
    }
`;

export const TableWrapper = styled.div`
    grid-column: span 2 / span 2;
    display: flex;
    flex-direction: column;
    gap: 4px;
    /* overflow: hidden; */
    
    @media only screen and (min-width: 601px) {
        max-height: 200px;
        padding: 14px;
        border-radius: 1rem;
        background-color: var(--theme-color-tertiary);
        border: 1px solid var(--table-border-color);
    }

    @media only screen and (max-width: 600px) {
        grid-column: span 1 / span 1;
        max-height: 200px;
    }
`;

export const Label = styled.label`
    display: flex;
    margin-bottom: 5px;
`;

export const FieldContainer = styled.div`
    ${(props) =>
        props?.$fullcol &&

        css`
                grid-column: span 2 / span 2;
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-content: start;

                @media only screen and (max-width: 600px) {
                    grid-column: span 1 / span 1;
                }
            `
    }
`;

export const SelectContainer = styled.div`
    
`;

export const ActionsContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
`;

export const FormError = styled.p`
    color: var(--color-error);
    font-size: 11px;
    padding-top: 2px;
`;

export const CheckboxWrapper = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const EmptyWrapper = styled.div`
    /* padding: 40px 0;
    border-radius: 1rem; */
    text-align: center;
    grid-column: span 2 / span 2;
    @media only screen and (max-width: 600px) {
        grid-column: span 1 / span 1;
    }
`;